const filterKIDDoc = (notificationObjs, createdAt) => {
  // used for checking accounts created prior to notification centre should not see the KID documents (as they are not new accounts)
  const createdAtDate = new Date(createdAt);
  const filterKIDNotification = notificationObjs.filter(
    ({ title }) =>
      title ===
      "Your Key Information Document is in your HRGO folder in the Resources section"
  );
  if (filterKIDNotification.length > 0) {
    const kidDate = new Date(filterKIDNotification[0].inserted_at);
    const noDaysDifference = (date1, date2) =>
      Math.abs((date2.getTime() - date1.getTime()) / (1000 * 3600 * 24));
    const days = noDaysDifference(createdAtDate, kidDate); // difference in days from acc creation to when kid notification was created.
    return days > 7;
  }
  return false;
};

const generateNotificationObjectArr = (list, lrDate, createdAt) => {
  let count = 0;
  let kidDocReadStatus = false;
  const lastreadDate = new Date(lrDate);
  const sortedNotifications = Object.values(list)
    .map((c) => {
      const curDate = new Date(c.inserted_at);
      const unread = lastreadDate < curDate;
      count += unread ? 1 : 0;
      if (
        c.title ===
          "Your Key Information Document is in your HRGO folder in the Resources section" &&
        unread
      )
        kidDocReadStatus = true;
      return {
        // transformed notification obj
        inserted_at: curDate,
        title: c.title,
        unread,
      };
    })
    .sort((c1, c2) => c2.inserted_at - c1.inserted_at);

  const kidDocOnOldAcc = filterKIDDoc(sortedNotifications, createdAt);

  const filteredNotifications = kidDocOnOldAcc
    ? sortedNotifications.filter(
        ({ title }) =>
          title !==
          "Your Key Information Document is in your HRGO folder in the Resources section"
      )
    : sortedNotifications;

  filteredNotifications.count =
    kidDocOnOldAcc && kidDocReadStatus ? count - 1 : count;

  return filteredNotifications;
};

export default generateNotificationObjectArr;
